export default function (props: any) {
    return (
        <svg
            width="27px"
            height="29px"
            viewBox="0 0 27 29"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <defs>
                <polygon
                    id="path-1"
                    points="313.235294 5594 313.235294 5603.54717 319 5601.88679 312 5616 305 5601.88679 310.764706 5603.54717 310.764706 5594"
                ></polygon>
                <filter x="-70.5%" y="-39.8%" width="226.8%" height="177.5%" filterUnits="objectBoundingBox" id="filter-2">
                    <feMorphology radius="1.2457743" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>
                    <feOffset dx="-1" dy="-1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
                    <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"></feComposite>
                    <feColorMatrix
                        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.171429401 0"
                        type="matrix"
                        in="shadowBlurOuter1"
                        result="shadowMatrixOuter1"
                    ></feColorMatrix>
                    <feMorphology radius="1.2457743" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter2"></feMorphology>
                    <feOffset dx="0" dy="0" in="shadowSpreadOuter2" result="shadowOffsetOuter2"></feOffset>
                    <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter2" result="shadowBlurOuter2"></feGaussianBlur>
                    <feComposite in="shadowBlurOuter2" in2="SourceAlpha" operator="out" result="shadowBlurOuter2"></feComposite>
                    <feColorMatrix
                        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.134687944 0"
                        type="matrix"
                        in="shadowBlurOuter2"
                        result="shadowMatrixOuter2"
                    ></feColorMatrix>
                    <feMerge>
                        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                        <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
                    </feMerge>
                </filter>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
                <g id="M端-CSR社会貢献" transform="translate(-299.000000, -5592.000000)" fillRule="nonzero">
                    <g id="直线" transform="translate(312.000000, 5605.000000) scale(1, -1) rotate(40.000000) translate(-312.000000, -5605.000000) ">
                        <use fill="black" fillOpacity="1" filter="url(#filter-2)" xlinkHref="#path-1"></use>
                        <path
                            stroke="#FFFFFF"
                            strokeWidth="1.2457743"
                            d="M313.858181,5593.37711 L313.858181,5602.71955 L320.186267,5600.89691 L312,5617.40184 L303.813733,5600.89691 L310.141819,5602.71955 L310.141819,5593.37711 L313.858181,5593.37711 Z"
                            fill="#000000"
                            fillRule="evenodd"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
